import { clsx } from 'clsx'

import { ChangeEvent, FC } from 'react'

import { ILevel } from '@/app/shared/components/program/constants'
import { selectStyles } from '@/app/shared/components/program/elements/level-list/constants'
import { getActiveLevel } from '@/app/shared/components/program/services'
import { ButtonComponent } from '@/app/shared/ui/button'
import { SelectComponent } from '@/app/shared/ui/select'

// interface
interface ILevelList {
  activeLevel: number
  levels: ILevel[]
  callback: (level: number) => void
}

// component
const LevelListComponent: FC<Readonly<ILevelList>> = ({ levels, activeLevel, callback }) => {
  const selectLevels = levels.map((el) => ({
    value: el.id,
    label: el.name,
  }))

  const callBackSelect = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectValue = levels.findIndex((el) => el.id === e.target.value)

    callback(selectValue)
  }

  return (
    <>
      <div className={'flex laptop:hidden'}>
        <SelectComponent
          option={selectLevels}
          value={levels[activeLevel]?.id}
          onChange={callBackSelect}
          stylesSelect={selectStyles}
        />
        <span
          className={
            'h-50px ml-[9px] flex w-[50px] items-center justify-center rounded-[15px] bg-warning font-semibold'
          }
        >
          {activeLevel + 1}
        </span>
      </div>
      <ul className={'hidden gap-y-[5px] laptop:grid'}>
        {levels.map((el, index) => (
          <li
            key={el.id}
            className={clsx('grid h-[50px] grid-cols-[300px_50px] gap-x-2.5', {
              hidden: !el.status,
            })}
          >
            <ButtonComponent
              color={'warning'}
              className={'h-full'}
              variant={getActiveLevel(el, levels[activeLevel])}
              onClick={() => callback(index)}
            >
              {el.name}
            </ButtonComponent>
            <ButtonComponent
              color={'warning'}
              className={'pointer-events-none h-full min-w-0 p-0'}
              variant={getActiveLevel(el, levels[activeLevel])}
            >
              {index + 1}
            </ButtonComponent>
          </li>
        ))}
      </ul>
    </>
  )
}

export default LevelListComponent
